import React from 'react'

const Join = () => {
  return (
    <>
      <div style={{ fontSize: "40px", marginTop: "200px" }}>Join</div>
      <div style={{ fontSize: "40px", marginTop: "10px" }}>Coming Soon...</div>
    </>
  )
}

export default Join